import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { copyForm } from '../utils/urls';

import { Forms } from 'types/forms';
import { ErrorModal } from 'types/modalTypes';

async function postForm({ accountId, formId }: TVariables): Promise<TResult> {
  const response = await fetch(copyForm(accountId, formId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult =
  | {
      Data: Forms;
      IsSuccess: boolean;
      StatusCode: number;
    }
  | undefined;

type TVariables = {
  accountId: number;
  formId: number;
};

type TSnapshot = unknown;

function useFormDetailsCopy(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    if (params.formId) {
      const apiResult = await postForm(params);
      if (apiResult?.StatusCode === 200) {
        queryClient.invalidateQueries(['forms_list']);
        return apiResult;
      }
    }
  });
}

export { useFormDetailsCopy };
